<div class="modal-header">
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body">
    <iframe id="pdf" name="pdf" width="100%" height="100%" [src]="getSourceURL(fileUrl)"></iframe>
</div>
